import { FC, useRef, useState, KeyboardEvent, FocusEvent } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { ButtonColor, ButtonSize, IconSize, Icons } from '../enums';
import Button from './Button';

const Input = styled.input`
  ${tw`px-3 py-2 rounded-full min-w-80 border border-slate-300 shadow-slate-300 outline-none`};

  &:focus {
    ${tw`shadow-[0_0_0_4px_rgb(var(--color-primary)_/_0.2)]`};
  }
`;

const EditButton = styled(Button)`
  ${tw`px-3 py-2 text-slate-700 text-lg rounded-full`};
`;

interface Props {
  text: string;
  handleSave: (value: string) => void;
}

const EditableString: FC<Props> = ({ text, handleSave }) => {
  const [isEditing, setIsEditing] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSave(e.currentTarget.value);
      setIsEditing(false);
    } else if (e.key === 'Escape') {
      if (inputRef.current) {
        inputRef.current.value = text;
        setIsEditing(false);
      }
    }
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    handleSave(e.target.value);
    setIsEditing(false);
  };

  return (
    <>
      {isEditing ? (
        <Input
          ref={inputRef}
          type="text"
          defaultValue={text}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />
      ) : (
        <EditButton
          icon={Icons.edit}
          size={ButtonSize.extraLarge}
          color={ButtonColor.default}
          iconSize={IconSize.medium}
          iconRight
          onClick={() => setIsEditing(true)}
        >
          <span>{text}</span>
        </EditButton>
      )}
    </>
  );
};

export default EditableString;
